import { HoopsCaptainInterestDTO } from 'src/services/dashboard/dto/HoopsSeasonRegistrationDTO';

export enum HoopsCaptainInterest {
    YES = 'yes',
    COULD_BE_CONVINCED = 'could-be-convinced',
    NO = 'no',
}

export namespace HoopsCaptainInterest {
    export const fromDTO = (dto: HoopsCaptainInterestDTO): HoopsCaptainInterest => {
        switch (dto) {
            case 'yes':
                return HoopsCaptainInterest.YES;
            case 'could-be-convinced':
                return HoopsCaptainInterest.COULD_BE_CONVINCED;
            default:
                return HoopsCaptainInterest.NO;
        }
    }

    /** Human-readable label for display in UI. */
    export const label = (interest: HoopsCaptainInterest): string => {
        switch (interest) {
            case HoopsCaptainInterest.YES:
                return 'Yes';
            case HoopsCaptainInterest.COULD_BE_CONVINCED:
                return 'Could be convinced';
            case HoopsCaptainInterest.NO:
                return 'No';
        }
    };
}
